var React = require('react');

function Numeral10 (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF"},React.createElement("path",{"d":"M5.8 16C3.4 16 1.5 16.1.6 16.1.3 16.1.3 15.7.6 15.7L1.1 15.7C3 15.7 3 15.3 3 14.3L3 4.1C1.8 4.3 1.2 4.4.7 4.3-2.77555756e-16 4.2.1 3.4.8 3.6 1.3 3.7 1.6 3.7 2 3.7 4.5 3.7 7.3 2.4 8.7 1L8.9 1 8.9 14.3C8.9 15.3 9.1 15.7 10.3 15.7L10.8 15.7C11.1 15.7 11.1 16.1 10.8 16.1 9.7 16 8.2 16 5.8 16zM20.1 16.2C16.6 16.2 13 14 13 8.5 13 3 16.7.8 20.1.8 23.5.8 27.2 3 27.2 8.5 27.2 13.9 23.5 16.2 20.1 16.2zM21.2 8.5C21.2 1.5 20.7 1.1 20 1.1 19.3 1.1 18.8 1.5 18.8 8.5 18.8 15.5 19.3 15.9 20 15.9 20.7 15.9 21.2 15.5 21.2 8.5z"})));
}

Numeral10.defaultProps = {"width":"28","height":"17","viewBox":"0 0 28 17"};

module.exports = Numeral10;

Numeral10.default = Numeral10;
